import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  text: "Insegno danza da quasi vent'anni e la domenica era sacra... ma solo per pianificare le lezioni della settimana. Con DANZA READY™ apro il Sistema di Costruzione delle Sessioni, scelgo il framework e in dieci minuti ho una lezione pronta. Mi sono ripresa i miei weekend e le mie allieve dicono che le sessioni non sono mai state così curate.",
  author: 'Maria Grazia C.',
  role: 'Insegnante di Danza, 52 anni',
  location: 'Bologna'
}, {
  text: 'Ho aperto la mia scuola tre anni fa e gestire allieve con livelli così diversi mi mandava in ansia: temevo sempre di chiedere troppo o troppo poco. I programmi di progressione di 4, 8 e 12 settimane mi hanno dato finalmente una struttura chiara. Ora so esattamente quando far avanzare ognuna e le iscrizioni sono aumentate.',
  author: 'Francesca R.',
  role: 'Titolare di Scuola di Danza, 38 anni',
  location: 'Milano'
}, {
  text: 'Tenevo corsi di fitness dance per signore adulte e mi mancava un metodo professionale: improvvisavo e mi sentivo poco credibile. La Libreria di Esercizi e la Checklist Anti-Vergogna hanno cambiato tutto. Le mie allieve sono più costanti e molte mi hanno detto che finalmente non si sentono giudicate.',
  author: 'Valentina T.',
  role: 'Istruttrice di Fitness Dance, 41 anni',
  location: 'Torino'
}, {
  text: "Dopo anni di insegnamento mi sentivo svuotata e sempre di corsa. Le Routine Pronte all'Uso e il Rituale Post-Danza di 7 minuti mi hanno restituito energia e ordine. Chiudo ogni lezione con un finale curato e le donne escono rilassate e motivate a tornare. Vale dieci volte il suo prezzo.",
  author: 'Chiara M.',
  role: 'Insegnante di Danza Espressiva, 47 anni',
  location: 'Firenze'
}, {
  text: "Sono passata dall'insegnamento occasionale a fare della danza la mia professione. Gli Strumenti di Coaching e le schede di monitoraggio mi hanno fatto sembrare — e sentire — finalmente professionale. Le allieve vedono i loro progressi nero su bianco e questo le fa restare. La fidelizzazione è il risultato più grande.",
  author: 'Alessia D.',
  role: 'Coach di Danza e Movimento, 35 anni',
  location: 'Roma'
}];
export function Testimonials() {
  return <section className="py-6 px-4 sm:px-6 bg-brand-cream border-y-4 border-brand-beige" data-id="element-150">
      <div className="text-center mb-4" data-id="element-151">
        <h2 className="text-2xl sm:text-3xl font-heading font-bold text-brand-taupe mb-1 uppercase leading-tight" data-id="element-152">
          COSA DICONO LE INSEGNANTI
        </h2>
        <p className="text-sm font-subheading font-bold text-brand-rose uppercase tracking-wide" data-id="element-153">
          Testimonianze di professioniste della danza
        </p>
      </div>

      <div className="flex flex-col gap-3" data-id="element-154">
        {testimonials.map((t, i) => <div key={i} className="bg-white border border-brand-beige p-3 rounded shadow-sm" data-id="element-155">
            <div className="flex gap-0.5 mb-1.5" data-id="element-156">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-brand-gold text-brand-gold" data-id="element-157" />)}
            </div>
            <p className="text-brand-taupe font-medium mb-2 leading-tight italic text-xs sm:text-sm" data-id="element-158">
              "{t.text}"
            </p>
            <div className="border-t border-brand-beige pt-2 flex items-center gap-2" data-id="element-159">
              <div className="w-8 h-8 rounded-full bg-brand-rose/20 flex items-center justify-center text-brand-rose font-bold text-sm border border-brand-rose/30" data-id="element-160">
                {t.author.charAt(0)}
              </div>
              <div className="leading-none" data-id="element-161">
                <p className="font-bold text-brand-taupe text-xs" data-id="element-162">
                  — {t.author}
                </p>
                <p className="text-[10px] text-brand-taupe/70 font-bold uppercase tracking-wide mt-0.5" data-id="element-163">
                  {t.role} — {t.location}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}